<template>
    <div id="weachetPay">
        <div class="weachetPay-top">
            <p>扫一扫付款（元）</p>
            <p>{{totalAmount}}</p>
        </div>
        <div class="weachetPay-bottom">
            <div class="bottom-left">
                <div class="left-top">
                    <img :src="imgData" alt="">
                </div>
                <div class="left-bottom">
                    <p><i></i></p>
                   <div class="left-bottom-right">
                       <p>打开手机微信</p>
                       <p>扫一扫进行付款</p>
                   </div>
                </div>
            </div>
            <div class="bottom-right">

            </div>
        </div>
        <div class="dialog-footer" style="text-align:right;">
<!--            <el-button type="primary" @click="save_class_info">保存</el-button>-->
<!--            <el-button type="primary" @click="closeModal">关闭</el-button>-->
        </div>

    </div>
</template>

<script>
    import {teaWeaPay,getOrderInfo} from "./js/orderInfoApi";

    export default {
        name: "weachetPay",
        props:{
            imgData:{
                type:String
            },
            orderId:{

            },
            totalAmount:{

            },
        },
        methods:{
            closeModal(){
                this.$emit('closeModal')
            },
            getOrderInfo(){
                getOrderInfo().then((res)=>{
                    if(res.errCode==0){
                        if(res.data.is_paid){

                        }else{

                        }
                    }
                }).catch(err=>{
                    console.log(err)
                })
            },

        },
        created() {

        }

    }
</script>

<style scoped lang="scss">
#weachetPay{
    .weachetPay-top{
        padding-left:0.8rem;
        p{
            font-size: 0.16rem;
            line-height: 0.4rem;
            color:#212121;
            &:last-of-type{
                color: #F5222D;
                font-weight: bold;
                font-size: 0.32rem;
                padding-left:0.2rem;
            }
        }
    }
    .weachetPay-bottom{
        margin-top: 0.1rem;
        padding:0 0.3rem;
        >div{
            display: inline-block;
            vertical-align: middle;
        }
    }
    .left-bottom{
        padding:0.1rem 0;
        >p{
            line-height: 0.4rem;
            height: 0.4rem;
            display: inline-block;
            width: 1.2rem;
            text-align: right;
            padding-right:0.3rem;
            i{
                /*margin-top: 0.1rem;*/
                display: inline-block;
                width: 0.4rem;
                height: 0.4rem;
                background: url('../../../../assets/images/pay_saoyisao.png') no-repeat center;
                background-size: contain;
            }
        }
    }
    .left-bottom-right{
        display: inline-block;
        p{
            color:#212121;
            font-size: 0.16rem;
            /*line-height: 0.3rem;*/
        }
    }
    .bottom-left{
        width: 2.7rem;
        padding:0.05rem;
        background: #EFF3F6;
        img{
            max-width: 2.6rem;
            max-height: 2.6rem;
        }
    }
    .bottom-right{
        margin-left: 0.38rem;
        width: 2.2rem;
        height: 3.36rem;
        background: url('../../../../assets/images/pay-back-icon.png') no-repeat center;
        background-size: contain;
    }
    @media (max-width: 980px) {
        .weachetPay-top{
            p{
                line-height:0.3rem ;
            }
        }
        .bottom-left{
            width: 2.1rem;
            img{
                max-width: 2rem;
                max-height: 2rem;
            }
        }
        .weachetPay-bottom{
            padding:0 ;
        }
        .left-bottom{
            >p{
                width: 0.5rem;
                padding-right: 0.05rem;
            }
        }
        .bottom-right{
            margin-left: 0.16rem;
            height: 2.8rem;
        }
    }
}
</style>